import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const Description = ({ label, value, ...containerProps }) => {
  return (
    <Box display="flex" justifyContent="space-between" {...containerProps}>
      <Typography variant="subtitle1" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="subtitle1" color="textPrimary">
        {value}
      </Typography>
    </Box>
  );
};

export default Description;

Description.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
